module.exports = __webpack_public_path__ + "img/cg_ruoyi_mirror.cc7ccd97.jpg";